/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesVoterDB_Voters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Voter Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, September 30, 2019 - 09:59:53 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/30/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const VoterDB_VotersList = Loadable({
    loader: () => import('../containers/VoterDB_Voters/VoterDB_VotersListContainer'),
    loading: Loading,
});

export const VoterDB_VotersForm = Loadable({
    loader: () => import('../containers/VoterDB_Voters/VoterDB_VotersEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesVoterDB_Voters.js